exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rating-stars{font-size:12px;width:60px;position:relative;padding:0;color:#767676}.rating-stars--large{font-size:16px;width:80px}.rating-stars--windows{font-size:14px}.rating-stars--windows.rating-stars--large{font-size:19px}.rating-stars__stars--top{color:#f7cc00;position:absolute;top:0;left:0;display:block;overflow:hidden;padding:0}.rating-stars__stars--bottom{padding:0;display:block;text-align:left}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/dist/cjs.js??ref--1-3!./shared/interim/product/rating/_rating-stars.scss
// module id = 775
// module chunks = 0